<template>
<div>    
    <Header :data="headerData" />
    <section id="contribute" class="bck__linear">
        <div class="container__section">
            <h1 class="title">
                Share your information about trails
            </h1>
            <h3 class="subtitle">
                Be part of this generous <span>hiking community</span> and <span>share</span> your journey!
            </h3>
            <div class="contrib__content">
                <div v-for="cat in shareData" :key="cat.svg" class="contrib__content--item">
                    <button v-if="cat.helper" class="contrib__content--info" @click="popup(cat.helper.popup)">
                        <Svg className="contrib__content--info-svg" :icon="cat.helper.svg"/>
                    </button>
                    <div class="contrib__content--img">
                        <Svg className="contrib__content--svg" :icon="cat.svg"/>
                    </div>
                    <div class="contrib__content--title">
                        {{cat.title}}
                    </div>
                    <div class="contrib__content--subtitle">
                        {{cat.subtitle}}
                    </div>
                    <div class="contrib__content--action">
                        <div v-for="link in cat.links" :key="link.svg" class="contrib__content--btn" @click.stop="logIn(link.page)">
                            <div class="contrib__content--logo">
                                <Svg className="contrib__content--btn-svg" :icon="link.svg"/>
                            </div>
                            {{link.title}}
                        </div>
                    </div>
                </div>                
            </div>

        </div>
</section>
<section class="bck__linear ">
    <div class="container__section">
        <h1 class="title">
            Why contribute ?
        </h1>
        <div class="contrib__why">
            <div v-for="why in dataWhy" :key="why.image" class="contrib__why--item">
                <img :src="`${$store.state.apiUrl}/images/static/about/small/${why.image}.webp`" alt="" class="contrib__why--img">
                <h3 class="contrib__why--title">
                    {{why.title}}
                </h3>
                <p class="contrib__why--p">
                    {{why.text}}        
                </p>
            </div>
        </div>
    </div>
</section> 
<section class="bck__linear">
        <div class="container__section">
            <h1 class="title">
                Our contributors
            </h1>
            <div class="contributors__container ">
                <router-link v-for="contrib in contributors"  :key="contrib._id" :to="{name:'User', params:{slug:contrib._id}}"  class="contributors__item">
                        <img :src="`${$store.state.apiUrl}/images/profil/small/${contrib.user.profilePicture.split('.')[0]}.webp`" :alt="`profile picture of ${contrib.user.name}`" class="contributors__img">
                        <img :src="`${$store.state.apiUrl}/images/flag/thumbnail/${contrib.user.nationality}.webp`" :alt="`nationality of ${contrib.user.name}`" class="contributors__flag">
                    <div class="contributors__content">
                        <h3 class="contributors__content--name">{{contrib.user.name}}</h3>
                        <div class="contributors__content--role"> Contributions : {{contrib.numberContributions}}</div>
                    </div>
                </router-link>
            </div>
        </div>
</section>
</div>
</template>

<script>

import axios from 'axios';

import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Header from '../components/Header';

import Svg from '../components/utils/Svg';
export default {
    components: {Header, Svg},
    setup(){
        const store = useStore();
        const router = useRouter();
        const contributors = ref([]);

        onMounted(() => {
            getContributors();
        })


        const getContributors = async () => {
            try{
                const res = await axios({
                    method:'GET',
                    url:'contributions/contributors'
                })

                if(res.status === 200){
                    contributors.value = res.data.contributors;
                }
                console.log(res);
            }catch(err){
                console.log(err.response);
            }
        }

        const headerData = {
            background:"contribution_medium2.jpg",
            backgroundPosition:"center",
            title: "Contributor",
            subtitle:"Share your informations with the community",
            layout:"page",
            scroll:"contribute",
            actions: [
                 {
                   "title" :  "How can I contribute ?",
                    "svg"   :  "",
                    "scroll"  :  "contribute",
                    "color" :  "white"
                },
                {
                     "title" :  "Become a contributor",
                    "svg"   :  "",
                    "link"  :  "Trails",
                    "color" :  "blue"
                }
            ]
        };

        const logIn = (page) => {
            console.log('in');
            if(store.state.loggedIn){
                router.push({ name:'Contribution', params:{page: page} })
            }else{
                store.commit("showSignupPopup");
            }
        }

        const popup = (name) => {
          store.state.popup.display = true,
          store.state.popup.data = {
            name
          }
        }

        const dataWhy = [
            {
                image: "contrib_hiker",
                title: "Help fellow hikers",
                text: "Choosing which trail to hike next is difficult, right? Each trail comes with its own wonders, challenges, and constraints. The data you provide will help hikers find and plan their next hike."
            },
            {
                image: "contrib_love",
                title: "CELEBRATE  THE TRAILS YOU LOVE",
                text: "What better way to celebrate your best hiking adventures than to share them with other hikers?"
            },
            {
                image: "contrib_collect",
                title: "Gather your own data in one place",
                text: " After an outdoor adventure, family and friends are often curious about our experiences. This platform is the best place to centralise all your hiking data (photo, video, blog, ...). "
            },
            {
                image: "contrib_product",
                title: "Collect contribution points and receive hiking products",
                text: "As contributors are key to improve the content of the platform, we designed a way to say thank you. <br><br> You get contribution points each time you add new contents to the website. Our most active contributors will regularly receive goodies, discounts or other interesting rewards."
            }
        ]

        const shareData= [
            {
                helper:{
                    svg: "infos",
                    target: false,
                    popup:"trail-contribution-helper"
                },
                svg:"trail2",
                title: "Hiking Trail",
                subtitle:"Share trail related data on the platform",
                links: [
                    {
                        target: '',
                        svg: 'plus',
                        title: 'Add new trail',
                        page:'addtrail'
                    },
                    // {
                    //     target: '',
                    //     svg: 'write',
                    //     page:'newpost',
                    //     title: 'As'
                    // },
                    // {
                    //     target: '',
                    //     svg: 'messenger',
                    //     page:'newpost',
                    //     title: 'Ask a question'
                    // }
                ]
            },
            // {
            //     helper:false,
            //     svg:"trailinfo",
            //     title: "Trail Data",
            //     subtitle:"Share information about trails",
            //     links: [
            //         {
            //             target: '',
            //             svg: 'camera',
            //             title: 'Your pictures'
            //         },
            //         // {
            //         //     target: '',
            //         //     svg: 'options',
            //         //     title: 'Trail details'
            //         // },
            //         {
            //             target: '',
            //             svg: 'link',
            //             title: 'Trails links'
            //         },
            //         // {
            //         //     target: '',
            //         //     svg: 'gpx',
            //         //     title: 'GPX tracks'
            //         // }
            //     ]
            // },
            {
                helper:false,
                svg:"messenger",
                title: "Ask your questions",
                subtitle:"Share your personal experience with other hikers",
                links: [
                    {
                        target: '',
                        svg: 'messenger',
                        page:'newpost',
                        title: 'ask a question'
                    },
                    // {
                    //     target: '',
                    //     svg: 'planning',
                    //     title: 'Preparation'
                    // },
                    // {
                    //     target: '',
                    //     svg: 'backpack',
                    //     title: 'Gear'
                    // },
                    // {
                    //     target: '',
                    //     svg: 'hiker',
                    //     title: 'Trail experience'
                    // }
                ]
            }
        ]
        return {
                contributors,
                dataWhy, 
                headerData,
                logIn,  
                popup,
                shareData
            }
    }
}
</script>

<style lang="scss">

@import '../style/main';

.contrib {
  &__content {
    padding: 4rem 0;
    display: flex;
    justify-content: center;

    @include respond(phone) {
      flex-direction: column;
    }

    &--item {
      position: relative;
      flex: 0 0 25%;
      border: 1px solid $color-grey-30;
      padding: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      box-shadow: $shadow;

      &:not(:last-child) {
        margin-right: 2rem;
        @include respond(phone) {
          margin-bottom: 3rem;
          margin-right: 0;
        }
      }
    }
    &--img {
      color: $color-blue-light;
      padding: 2rem;
    }
    &--title {
      font-size: 1.8rem;
      letter-spacing: 0.2rem;
      text-transform: uppercase;
      font-weight: 700;
      text-align: center;
      margin-bottom: 0.7rem;
    }
    &--subtitle {
      font-weight: 300;
      font-size: 1.6rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      text-align: center;

      height: 5rem;
      display: flex;
      align-items: center;
    }
    &--svg {
      @include svg(8rem);
    }
    &--info {
      color: inherit;
      position: absolute;
      background-color: $color-white;
      top: 0.8rem;
      right: 0.8rem;
      outline: none;
      border: none;
      cursor: pointer;
      &-svg {
        @include svg(2rem);
      }
    }
    &--action {
      flex: 1;
      width: 100%;
      margin-top: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &--logo{
        width: 2rem;
        margin-right: 1.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &--btn {
        @include buttonNoStyle;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid currentColor;
        width: 100%;
        padding: 1.2rem 2rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;

        border-radius: 5px;

        box-shadow: $shadow-light;

        transition: all 0.2s;
        text-align: center;

        &:hover {
            background-color: $color-grey-75;
            color: $color-white;
        }
        &:not(:last-child) {
            margin-bottom: 0.8rem;
        }

        &-svg {
            @include svg(2rem);
        }
    }
  }
  &__why {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 4rem 0;

    @include respond(phone) {
      flex-direction: column;
    }
    &--item {
      flex: 0 0 23%;

      @include respond(phone) {
        margin-bottom: 4rem;
      }
    }
    &--title {
      font-size: 1.6rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1rem;
      margin-bottom: 1rem;

      @include respond(phone) {
        font-size: 1.8rem;
        letter-spacing: 0.2rem;
        line-height: 2.4rem;
      }
    }
    &--p {
      font-size: 1.3rem;
      letter-spacing: 0.1rem;
      text-align: justify;
      @include respond(phone) {
        font-size: 1.5rem;
      }
    }
    &--img {
      width: 100%;
      height: auto;
      margin-bottom: 1.5rem;
    }
  }
}

.contributors {

  &__title {
    padding: 4rem 1rem 4rem 1rem;
    text-align: center;
    font-size: 2rem;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
  }

  &__container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    height: 100%;
    padding: 4rem 0;
  }

  &__item {
      color:inherit;
      text-decoration: none;
    position: relative;
    flex: 0 0 18%;
    width: 100%;
    box-shadow: 0 1.5rem 4rem rgba($color-black, 0.15);

    cursor: pointer;

    margin-bottom: 3rem;

    &:not(:last-child) {
      margin-right: 3rem;
      @include respond(phone) {
        margin-right: 0;
      }
    }
    @include respond(tab-port) {
      flex: 0 0 28%;
    }

    @include respond(phone) {
      flex: 0 0 90%;
    }
  }

  &__img {
    width: 100%;
    height: auto;
  }

  &__flag {
    position: absolute;
    top: 1rem;
    left: 1rem;

    width: 2rem;
    height: auto;

    @include respond(phone) {
      width: 6rem;
    }
  }

  &__content {
    height: 12rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &--name {
      font-size: 1.6rem;
      font-weight: 600;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
      text-decoration: none;
      color: inherit;
      padding: 0.5rem 1rem;
      text-align: center;
    }

    &--role {
      font-size: 1.4rem;
      font-weight: 300;
      text-align: center;
    }
  }

  &__btn {
    padding: 1rem 2rem;
    background-color: $color-grey-75;
    text-decoration: none;
    color: $color-white;
    font-size: 1.8rem;
    font-weight: 400;
    text-transform: uppercase;
    border-radius: 5px;

    box-shadow: 0 1.5rem 4rem rgba($color-black, 0.15);
    margin: 2rem auto;

    transition: all 0.3s;
    &:hover {
      transform: translateY(-0.3rem);
      background-color: darken($color-grey-75, 5);
    }

    &--container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}



</style>